import React from 'react';
import PropTypes from 'prop-types';
import enhanceWithClickOutside from 'react-onclickoutside';
import cx from 'classnames';
import { noop } from 'lodash';

import styles from './DropdownTextEditorTool.scss';

class DropdownTextEditorTool extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onToggle: PropTypes.func,
    renderToggle: PropTypes.func,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        label: PropTypes.node.isRequired,
      }),
    ),
    value: PropTypes.number,
    className: PropTypes.string,
  };

  static defaultProps = {
    onToggle: noop,
  };

  state = {
    isOpened: false,
  };

  handleClickOutside = () => {
    if (this.state.isOpened) {
      this.close();
    }
  };

  toggle = () => {
    this.setOpenedState(!this.state.isOpened);
  };

  setOpenedState = isOpened => {
    this.props.onToggle(isOpened);
    this.setState({
      isOpened,
    });
  };

  close = () => {
    this.setOpenedState(false);
  };

  handleListItemClick = option => e => {
    e.preventDefault();
    this.props.onChange(option);
    this.close();
  };

  renderList = (options, selectedValue) => (
    <div className={styles.optionsList}>
      {options.map(option => (
        <div
          key={option.value}
          onMouseDown={this.handleListItemClick(option)}
          className={
            selectedValue === option.value
              ? styles.activeOptionItem
              : styles.optionItem
          }
        >
          {option.label}
        </div>
      ))}
    </div>
  );

  renderToggle = () => {
    const { isOpened } = this.state;
    const { renderToggle } = this.props;

    return renderToggle({
      isOpened,
      toggle: this.toggle,
    });
  };

  render = () => {
    const { isOpened } = this.state;
    const { options, value, className } = this.props;

    return (
      <div className={cx(className, styles.container)}>
        {this.renderToggle()}
        {isOpened && this.renderList(options, value)}
      </div>
    );
  };
}

export default enhanceWithClickOutside(DropdownTextEditorTool);
